export enum CarDetailsErrorCauses {
    ERROR = 'error',
    NOT_FOUND = 'not-found',
}

export class CarDetailsError extends Error {
    cause: CarDetailsErrorCauses;

    errorName: string;

    constructor(cause: CarDetailsErrorCauses) {
        super();
        this.cause = cause;
        this.name = 'CarDetailsError';
    }
}
